import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { QUEUE_OFFLINE_ORDERS_ROUTES } from './routes';
import { QueuedOfflineOrdersScreen } from '@/screens/queued-offline-orders';
import { QueuedOfflineOrdersStackParams } from './types';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

const Stack = createStackNavigator<QueuedOfflineOrdersStackParams>();

export const QueuedOfflineOrdersStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={options}>
      <Stack.Screen
        component={QueuedOfflineOrdersScreen}
        name={QUEUE_OFFLINE_ORDERS_ROUTES.Base}
      />
    </Stack.Navigator>
  );
};
